import React from "react";
import { BiChevronRight } from "react-icons/bi";

const Booking = () => (
  <div className="w-[214px] h-[60px] overflow-hidden flex justify-center items-center">
    <button className="font-titleFont text-xl text-white hover:text-darkPink bg-transparent transition-hover relative duration-300 font-semibold w-52 h-14 group underline decoration-darkPink underline-offset-8 flex items-center justify-center gap-1">
      Book your course
      {/* <span className="absolute w-full h-1 bg-white -left-1 -top-1 -translate-x-[100%] group-hover:translate-x-0 transition-all duration-500"></span>
      <span className="absolute w-1 h-full bg-white -top-1 -left-1 -translate-y-[100%] group-hover:translate-y-0 transition-all duration-200"></span>
      <span className="absolute w-full h-1 bg-white -right-1 -bottom-1 translate-x-[100%] group-hover:translate-x-0 transition-all duration-500"></span>
      <span className="absolute w-1 h-full bg-white -bottom-1 -right-1 translate-y-[100%] group-hover:translate-y-0 transition-all duration-200"></span> */}
      <span>
        <BiChevronRight size={25} />
      </span>
    </button>
  </div>
);

export default Booking;
